import React, { useState } from "react";
import { Button, Input } from "antd";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { QuestionForm } from "./QuestionForm";

const { TextArea } = Input;

const sectionData = {
  organization: [
    {
      title: "Company Details",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Discloser Details",
      questions: [
        {
          questionId: "3/18/5/4",
          label: "Type of alignment being reported for this financial metric",
          type: "select",
          options: [
            {
              key: "Alignment with a sustainable finance taxonomy",
              value: "Alignment with a sustainable finance taxonomy",
              _id: "678114c77e926d878a7ae4ae",
            },
            {
              key: "Alignment with our climate transition plan",
              value: "Alignment with our climate transition plan",
              _id: "678114c77e926d878a7ae4af",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4ad",
        },
        {
          questionId: "3/18/5/5",
          label: "Taxonomy under which information is being reported*",
          type: "select",
          options: [
            {
              key: "EU Taxonomy for Sustainable Activities",
              value: "EU Taxonomy for Sustainable Activities",
              _id: "678114c77e926d878a7ae4b1",
            },
            {
              key: "Other, please specify",
              value: "Other, please specify",
              _id: "678114c77e926d878a7ae4b2",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b0",
        },
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
        {
          questionId: "3/18/5/7",
          label:
            "Percentage share of selected financial metric aligned in the reporting year (%)",
          type: "number",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b8",
        },
      ],
    },
    {
      title: "Nature of Work",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Customer Detail",
      questions: [
        {
          questionId: "3/24/1/1",
          label:
            "Is the entity compliant with the applicable environmental law/ regulations/ guidelines in India. ",
          type: "select",
          options: [
            {
              key: "Yes",
              value: "Yes",
              _id: "6781153b7e926d878a7ae5e6",
            },
            {
              key: "No",
              value: "No",
              _id: "6781153b7e926d878a7ae5e7",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "6781153b7e926d878a7ae5e5",
        },
        {
          questionId: "3/24/1/2",
          label: "S. No.",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5e9",
          },
          _id: "6781153b7e926d878a7ae5e8",
        },
        {
          questionId: "3/24/1/3",
          label:
            "Specify  the law / regulation / guidelines  which  was not complied with",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5eb",
          },
          _id: "6781153b7e926d878a7ae5ea",
        },
        {
          questionId: "3/24/1/4",
          label: "Provide details  of the non- compliance",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5ed",
          },
          _id: "6781153b7e926d878a7ae5ec",
        },
        {
          questionId: "3/24/1/5",
          label:
            "Any fines / penalties / action taken by regulatory agencies such as pollution control boards or by courts",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5ef",
          },
          _id: "6781153b7e926d878a7ae5ee",
        },
      ],
    },
    {
      title: "Employees / Workers",
      questions: [
        {
          questionId: "3/23/1/1",
          label:
            "Is flaring relevant to your oil and gas production activities?",
          type: "select",
          options: [
            {
              key: "Yes",
              value: "Yes",
              _id: "678115307e926d878a7ae5df",
            },
            {
              key: "No",
              value: "No",
              _id: "678115307e926d878a7ae5e0",
            },
          ],
          dynamicOptions: null,
          condition: {
            questionId: "3/23/1/1",
            value: "Yes",
            operator: "equals",
            _id: "678115307e926d878a7ae5e1",
          },
          _id: "678115307e926d878a7ae5de",
        },
        {
          questionId: "3/23/1/2",
          label:
            "Describe your organization's efforts to reduce flaring, including any flaring reduction targets.",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678115307e926d878a7ae5e2",
        },
      ],
    },
    {
      title: "Reporting Boundaries",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  environment: [
    {
      title: "Environmental Policies",
      questions: [
        {
          questionId: "3/24/1/1",
          label:
            "Is the entity compliant with the applicable environmental law/ regulations/ guidelines in India. ",
          type: "select",
          options: [
            {
              key: "Yes",
              value: "Yes",
              _id: "6781153b7e926d878a7ae5e6",
            },
            {
              key: "No",
              value: "No",
              _id: "6781153b7e926d878a7ae5e7",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "6781153b7e926d878a7ae5e5",
        },
        {
          questionId: "3/24/1/2",
          label: "S. No.",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "asda",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5e9",
          },
          _id: "6781153b7e926d878a7ae5e8",
        },
        {
          questionId: "3/24/1/3",
          label:
            "Specify  the law / regulation / guidelines  which  was not complied with",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5eb",
          },
          _id: "6781153b7e926d878a7ae5ea",
        },
        {
          questionId: "3/24/1/4",
          label: "Provide details  of the non- compliance",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5ed",
          },
          _id: "6781153b7e926d878a7ae5ec",
        },
        {
          questionId: "3/24/1/5",
          label:
            "Any fines / penalties / action taken by regulatory agencies such as pollution control boards or by courts",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5ef",
          },
          _id: "6781153b7e926d878a7ae5ee",
        },
        {
          questionId: "3/24/1/6",
          label: "Corrective action taken, if any",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5f1",
          },
          _id: "6781153b7e926d878a7ae5f0",
        },
        {
          questionId: "3/24/1/7",
          label: "provide details of all such non-compliances",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: {
            questionId: "3/24/1/1",
            value: "Yes",
            operator: "equals",
            _id: "6781153b7e926d878a7ae5f3",
          },
          _id: "6781153b7e926d878a7ae5f2",
        },
      ],
    },
    {
      title: "Energy Usage",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Water Consumption",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Waste Management",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Biodiversity",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  social: [
    {
      title: "Community Engagement",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Labor Practices",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Diversity & Inclusion",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Health & Safety",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Human Rights",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  governance: [
    {
      title: "Ethical Standards",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Board Structure",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Risk Management",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Compliance",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Transparency",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  "scope-1-2": [
    {
      title: "Ethical Standards",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Board Structure",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Risk Management",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Compliance",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Transparency",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  "scope-3": [
    {
      title: "Ethical Standards",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Board Structure",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Risk Management",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Compliance",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Transparency",
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          placeholder: "1234",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
};

const ViewDynamicForm = ({ viewForm, onClose }) => {
  const [fieldOne, setFieldOne] = useState("");
  const [fieldTwo, setFieldTwo] = useState("");
  const [errorFieldOne, setErrorFieldOne] = useState(false);
  const [errorFieldTwo, setErrorFieldTwo] = useState(false);

  const handleClear = () => {
    setFieldOne("");
    setFieldTwo("");
    setErrorFieldOne(false);
    setErrorFieldTwo(false);
  };

  const handleSave = () => {
    let hasError = false;

    if (!fieldOne.trim()) {
      setErrorFieldOne(true);
      hasError = true;
    } else {
      setErrorFieldOne(false);
    }

    if (!fieldTwo.trim()) {
      setErrorFieldTwo(true);
      hasError = true;
    } else {
      setErrorFieldTwo(false);
    }

    if (!hasError) {
      console.log("Field One Value:", fieldOne);
      console.log("Field Two Value:", fieldTwo);
    }
  };

  const ViewSections = ({ title = "", data = [] }) => {
    return (
      <div className="my-2 ">
        <h3 className="text-teal-500 text-xl">{title}</h3>
        <div className="border border-b"></div>
        <div>
          {data.map((iteam, index) => (
            <div key={index} className="my-4">
              <h4 className="text-teal-500 text-lg">{iteam.title}</h4>
              <div>
                <QuestionForm questions={iteam.questions} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="flex justify-center my-4">
      <DialogBox
        open={viewForm !== null}
        onCancel={onClose}
        width="90%"
        maxWidth="1050px"
      >
        <div>
          <h3 className="text-teal-500 text-xl">View Form</h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <ViewSections
              title="Organization"
              data={sectionData.organization}
            />
            <ViewSections title="Governance" data={sectionData.governance} />
            <ViewSections title="Environment" data={sectionData.environment} />
            <ViewSections title="Social" data={sectionData.social} />
            <ViewSections title="Scope-3" data={sectionData["scope-3"]} />
            {/* <QuestionForm questions={options} /> */}
          </div>
        </div>
      </DialogBox>
    </div>
  );
};

export default ViewDynamicForm;
